import * as types from "./constants";
import _ from 'lodash';

let initState = {
    layouts: {},
    layoutElements: {},
    flashMessages: []
};

export default function reducer(state = initState, action = "") {

    if (action.type.startsWith(types.PREFIX)) {
        switch (action.type) {
            case types.STORE_LAYOUT:
            {
                let layoutChanges = {};
                layoutChanges[action.payload.key] = action.payload.layout;
                state = {
                    ...state,
                    layouts: {
                        ...state.layout,
                        ...layoutChanges
                    }
                }
                break;
            }
            case types.STORE_LAYOUT_ELEMENT_LIST:
            {
                let layoutChanges = {};
                layoutChanges[action.payload.key] = action.payload.layoutElements;
                state = {
                    ...state,
                    layoutElements: {
                        ...state.layoutElements,
                        ...layoutChanges
                    }
                }
                break;
            }
            case types.FLASH_MESSAGE_SHOW:
            {
                console.log("show");
                state = {
                    ...state,
                    flashMessages: [
                        ...state.flashMessages,
                        action.payload
                    ]
                }
                break;
            }
            case types.FLASH_MESSAGE_HIDE:
            {
                console.log("hide");
                state = {
                    ...state,
                    flashMessages: _.filter(state.flashMessages, (m)=>m.id != action.payload.id)
                }
                break;
            }
            default:
                break;
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/storeState/ui/reducer.js